// this file is automatically generated by git.revision.js script
export const versions = { revision: 'd45f8273fd' }; 
 //expose the commit hash to the window object 
//@ts-ignore 
window.rd_version = 'd45f8273fd';
